import script from "./Subscription_Fail.vue?vue&type=script&setup=true&lang=js"
export * from "./Subscription_Fail.vue?vue&type=script&setup=true&lang=js"

import "./Subscription_Fail.vue?vue&type=style&index=0&id=4d6837fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d6837fe"]])

export default __exports__